import React from "react";
import { Link, useLocation } from "react-router-dom";

const PitaCukai = () => {
  const location = useLocation();


  const renderNavItem = (to, label, iconClass) => {
    const isActive = location.pathname === to;

    return (
      <li
        className={`kt-menu__item ${isActive ? "kt-menu__item--active" : ""}`}

        key={to}
      >
        <Link className="kt-menu__link" to={to}>
          <i className={`kt-menu__link-icon ${iconClass}`}></i>
          <span className="kt-menu__link-text">{label}</span>
        </Link>
      </li>
    );
  };

  return (
    <>
      {renderNavItem(
        "/pita/browse",
        "Tanda Terima Pita Cukai",
        "flaticon-delete-2"
      )}

      {renderNavItem(
        "/pita/pelekatan",
        "Pelekatan Pita Cukai",
        "flaticon-notes "
      )}
    </>
  );
};

export default PitaCukai;
